import { Component } from '@theme/component';

/**
 * Article share row — copy-link button + social share links.
 *
 * The copy button uses this theme's declarative on:click convention
 * (assets/component.js), which requires the closest ancestor Component
 * instance to own the handler method — hence this custom element.
 */
export class ArticleShareRow extends Component {
  /** @type {ReturnType<typeof setTimeout> | undefined} */
  #copiedTimeout;

  /**
   * @param {Event} event
   */
  copyLink(event) {
    event.preventDefault();

    const url = this.dataset.textToCopy;
    if (!url) return;

    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).catch(() => {});
    }

    this.classList.add('is-copied');
    clearTimeout(this.#copiedTimeout);
    this.#copiedTimeout = setTimeout(() => {
      this.classList.remove('is-copied');
    }, 2000);
  }
}

if (!customElements.get('article-share-row')) {
  customElements.define('article-share-row', ArticleShareRow);
}
